import * as Sentry from "@sentry/react"

export function isMonitoringEnabled(): boolean {
  return Boolean(import.meta.env.VITE_GLITCHTIP_DSN)
}

export function initMonitoring(): void {
  if (!isMonitoringEnabled()) {
    return
  }

  Sentry.init({
    dsn: import.meta.env.VITE_GLITCHTIP_DSN,
    environment: import.meta.env.VITE_APP_ENV,
    release: import.meta.env.VITE_APP_RELEASE || undefined,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
  })
}

export function captureMonitoringException(error: unknown): void {
  if (!isMonitoringEnabled()) {
    return
  }
  Sentry.captureException(error)
}

export { Sentry }
